module.exports = __webpack_public_path__ + "static/media/logo.791bcf9f.png";